(function() {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGridMisc', sodGridMisc);

    function sodGridMisc() {
        return {
            restrict: 'E',
            scope: { config: '=' },
            templateUrl: 'common/components/sod-grid-misc',
            controller: sodGridMiscCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridMiscCtrl($scope, lodash, GroupFilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.setSort = setSort;
                vm.getSort = null;

                vm.rows = [];
                vm.count = vm.rows.length;
                vm.groupFilterFactory = GroupFilterFactory(vm.config);

                init();
            }

            function init() {
                var groupFilterFactoryApplyFilter = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id].join('.'), function (e, eventData) {
                    var rows = lodash.get(eventData, 'rows', []);
                    var count = lodash.get(eventData, 'count', []);

                    vm.rows = rows;
                    vm.count = count;
                    formPagination();
                });
                var groupFilterFactoryLoading = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventLoading].join('.'), function (e, eventData) {
                    vm.isLoading = eventData;
                });
                $scope.$on('destroy', function() {
                    groupFilterFactoryApplyFilter();
                    groupFilterFactoryLoading();
                });
            }

            function setSort() {
                vm.groupFilterFactory.setSort(vm.config.id, vm.getSort());
            }

            function formPagination() {
                var list = [];
                var pageLimit = vm.paginationSize;
                var total = Math.ceil(vm.count / vm.pageSize);
                var upperLimit, lowerLimit;
                var currentPage = lowerLimit = upperLimit = Math.min(vm.page, total);

                for (var b = 1; b < pageLimit && b < total;) {
                    if (lowerLimit > 1 ) {
                        lowerLimit--; b++;
                    }
                    if (b < pageLimit && upperLimit < total) {
                        upperLimit++; b++;
                    }
                }

                for (var i = lowerLimit; i <= upperLimit; i++) {
                    if (i == currentPage){
                        list.push({ pageNumber: i, isActive: true });
                    }
                    else{
                        list.push({ pageNumber: i });
                    }
                }

                vm.paginations = list;
            }
        }
    }
})();